import { IProduct } from '../../models';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { PlusIcon, MinusIcon } from '@heroicons/react/solid';
import MycarouselProduct from './MycarouselProduct';
// import CountdownTimer from '../Countdown/CountdownTimer';

const LIMIT = 150;

// TODO: @andrea - Rimuovi dopo CYBER MONDAY
// const BLACKFRIDAY = 1_669_708_800_000;

function truncate(text: string = '') {
  if (text.length <= LIMIT) {
    return text;
  }
  const subString = text.slice(0, LIMIT - 1);
  return subString.slice(0, subString.lastIndexOf(' ')) + '...';
}

export default function ProductTitleDescription({
  product,
  gallery
}: {
  product: IProduct;
  gallery: string[];
}) {
  const { productName = '', description = '', video = '' } = product;
  const { t } = useTranslation();
  const [more, setMore] = useState(false);

  return (
    <>
      <div className="flex justify-between mb-4 lg:mb-0">
        <h1 className="text-3xl font-bold text-gray-900 font-sans">
          {productName}
        </h1>
      </div>
      <div className="lg:hidden">
        <MycarouselProduct gallery={gallery} video={video} alt={productName} />
      </div>
      <div className="mt-6 prose prose-sm" />
      <p className="text-gray-400 font-normal">
        {more ? description : truncate(description)}
      </p>
      {description.length >= LIMIT && (
        <button
          onClick={() => setMore(!more)}
          type="button"
          className="inline-flex items-center text-sm font-normal text-black focus:outline-nones mt-2"
        >
          {more ? (
            <>
              {t('READ_LESS')} <MinusIcon className="w-4 h-4 ml-1" />
            </>
          ) : (
            <>
              {t('READ_MORE')} <PlusIcon className="w-4 h-4 ml-1" />
            </>
          )}
        </button>
      )}

      {/* NOTE: TIMER */}
      {/* <div className="mt-6 bg-primary text-black px-2 py-1 lg:px-3 lg:py-2 rounded-sm flex flex-col items-center">
        <div className="mb-3">{t('COUNTDOWN.DESC')}</div>
        <CountdownTimer targetDate={BLACKFRIDAY} />
      </div> */}
    </>
  );
}
